// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"6691887c","703":"922d6015"}[chunkId] + ".chunk.js";
};